import * as React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

import { cn } from 'utils/cn';

interface NumberInputProps extends Omit<NumericFormatProps, 'customInput'> {
    className?: string;
}

const NumberInput = React.forwardRef<HTMLInputElement, NumberInputProps>(({ className, ...props }, ref) => {
    return (
        <NumericFormat
            {...props}
            getInputRef={ref}
            className={cn(
                'border-input bg-background ring-offset-background file:text-foreground placeholder:text-muted-foreground flex h-10 w-full rounded-md border px-3 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                className,
            )}
            valueIsNumericString
        />
    );
});
NumberInput.displayName = 'NumberInput';

export { NumberInput };
